import React, { useState, useEffect } from "react";
import { DataTable, Modal } from "../components";
import { getCustomers, getLocationsByCustomerId } from "../services";
import { getUserToken } from "../helpers";
import { Link } from 'react-router-dom';
import jwtDecode from "jwt-decode";

const Home = () => {

  const [customers, setCustomers] = useState();
  const [locations, setLocations] = useState();
  const [locationId, setLocationId] = useState();
  const [user, setUser] = useState();
  const [modalHeader, setModalHeader] = useState();
  const [modalVisible, setModalVisible] = useState(false);

  const openDashboard = async (id, name) => {
    const loc = await getLocationsByCustomerId(id);
    setLocations(loc);
    setModalHeader("Locatie kiezen voor klant " + name);
    if (modalVisible == false) setModalVisible(true);
    else setModalVisible(false);
    document.querySelector('.overlay').classList.toggle('modal__active');
  }

  useEffect(() => {
    // set customers from api request
    const body = [];
    const token = getUserToken();
    setUser(jwtDecode(token));
    getCustomers().then((res) => {
      res.customers.map((customer, i) => {
        const icon = <a onClick={() => openDashboard(customer.id, customer.name)}><i className="fas fa-chart-bar"></i></a>;
        const row = [customer.id, customer.name, customer.contact, "Ja", icon];
        body.push(row);
      });
      setCustomers(body);
    });
  }, []);

  const head = ["No", "Klantnaam", "Manager", "Actief", "Bekijken"];
  if (customers) {
    return (
      <div className="container">
        {modalVisible && 
          <Modal header={modalHeader}>
            <div>
              <select
                required="true"
                id="selectbox__location"
                onChange={(e) => {
                  setLocationId(e.target.value);
                  console.log(locationId);
                }}
                className="form__fields__field__input"
              >
                <option>Selecteer een locatie</option>
                {locations && locations.locations.map((value, index) => {
                  return <option key={index} value={value.id}>{value.name}</option>
                })}
              </select>
              {locationId &&               
                <Link className="modal__submit__button" to={"/dashboard/"+locationId}>
                  Dashboard
                </Link>
              }
            </div>
          </Modal>
        }
        <h2 className="container__title">Welkom terug {user.firstname}</h2>
        <div className="form__container">
          <DataTable head={head} body={customers} />
        </div>
      </div>
    );
  } else return <div></div>;  
}

export default Home;